import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Container = styled(Box)(({ theme }) => ({
  height: '100%',

  '& .body': {
    display: 'flex',
    alignItems: 'flex-start',

    gap: '12px',
    marginTop: '12px',

    '& .left': {
      flex: 1,
      height: '85%',
      overflow: 'scroll',
      border: `1px solid ${theme.palette.divider}`, //theme.GREY_VARIANT
      borderRadius: theme.shape.customBorderRadius.main,

      '& .tabs': {
        display: 'flex',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.divider}`, //theme.GREY_VARIANT

        '& .tab': {
          flex: 1,
          display: 'flex',
          height: '42px',
          cursor: 'pointer',

          svg: {
            margin: 'auto',
            color: 'rgba(0, 0, 0, 0.08)',
          },
        },

        '& .active': {
          borderBottom: `3px solid ${theme.palette.primary.main}`,

          svg: {
            color: theme.palette.primary.main,
          },
        },
      },
    },

    '& .right': {
      flex: 1,
      height: '83%',
      overflow: 'scroll',
      border: `1px solid ${theme.palette.divider}`, //theme.GREY_VARIANT
      borderRadius: theme.shape.customBorderRadius.main,
      padding: '0 12px 12px',
    },

    '& .right-dial': {
      backgroundColor: theme.palette.background.default, //theme.PRIMARY_BACKGROUND
      borderRadius: theme.shape.customBorderRadius.small,
      width: '209px',
      maxWidth: '209px',
      height: '84%',

      '& .content': {
        margin: '12px',

        '& .title': {
          fontSize: '1rem',
          lineHeight: '18px',
          textAlign: 'center',

          fontWeight: 500,
          letterSpacing: '0.15px',

          color: theme.palette.text.secondary,
          marginBottom: '24px',
        },
      },
    },
  },
}))
